import { AutogenLayoutDriverSettlementProfileFilter } from "./autogen/AutogenLayoutDriverSettlementProfileFilter";

export class DriverSettlementProfileFilter extends AutogenLayoutDriverSettlementProfileFilter {
    onLoad(): void | Promise<void> {
        this.layoutProfile.textboxDescr.enabled = false;
        this.layoutProfile.layoutProfileColor.visible = false;
    }
}
